import { useParams } from "react-router";
import PdfViewer from "../../PdfViewer";
import MallabhumPrayas from "../../MallabhumPrayas";

const DarpanView = () => {
  const { id } = useParams();
  if (!id) {
    return null;
  }
  const currentUrl =
    window.location.hostname === "localhost"
      ? window?.location.origin
      : "https://mallabhumprayas.org/";
  const pdfFile =
    id === "1.0"
      ? `${currentUrl}/assets/pdf/Samaj-Darpan-1.0.pdf`
      : id === "2.0"
      ? `${currentUrl}/assets/pdf/Samaj-Darpan-2.0.pdf`
      : id === "3.0"
      ? `${currentUrl}/assets/pdf/Samaj-Darpan-3.0.pdf`
      : id === "4.0"
      ? `${currentUrl}/assets/pdf/Samaj-Darpan-4.0.pdf`
      : `${currentUrl}/assets/pdf/Samaj-Darpan-1.0.pdf`;
  return (
    <div>
      <div>
        <h1
          style={{
            fontSize: "36px",
            fontWeight: "bold",
            backgroundColor: "#2d662f",
            color: "#fff",
            textAlign: "center",
            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)",
            letterSpacing: "1.5px",
            fontFamily: "'Arial', sans-serif",
            padding: "10px 20px",
            borderRadius: "8px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <MallabhumPrayas style={{ marginRight: "10px" }} />
          Samaj Darpan {id}
        </h1>
      </div>
      <PdfViewer pdfFile={pdfFile} />
    </div>
  );
};

export default DarpanView;
